import React from 'react';
import { Link } from 'react-router-dom';
import { media_url } from '../../hooks/useBlog';
import { FaClock, FaCalendar, FaArrowRight } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import './NewsGrid.scss';

const NewsGrid = ({ posts, loading }) => {
  if (loading) {
    return <div className="news-loading">Cargando noticias...</div>;
  }

  if (!posts || posts.length === 0) {
    return <div className="news-empty">No hay noticias disponibles</div>;
  }

  // Skip first 4 posts (already shown in featured)
  const displayPosts = posts.slice(4);

  return (
    <div className="news-grid-section">
      <div className="news-grid">
        {displayPosts.map((post) => (
          <Link
            key={post.id}
            to={`/post/${post.slug || post.id}?id=${post.id}`}
            className="news-card"
          >
            <div 
              className="news-card-image"
              style={{ backgroundImage: `url(${media_url(post.image)})` }}
            >
              {post.category && (
                <span className="news-card-category">
                  {typeof post.category === 'object' ? post.category.name : post.category}
                </span>
              )}
            </div>
            <div className="news-card-content">
              <div className="news-card-meta">
                <span>
                  <FaCalendar /> {new Date(post.created).toLocaleDateString('es-ES', {
                    day: 'numeric',
                    month: 'short'
                  })}
                </span>
                <span>
                  <FaClock /> 5 min
                </span>
              </div>
              <h3 className="news-card-title">{post.title}</h3>
              <p className="news-card-excerpt">{post.excerpt}</p>
              <div className="news-card-footer">
                <span className="read-more">
                  Leer más <FaArrowRight />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NewsGrid;
